import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const integrationApi = createApi({
  reducerPath: 'integrationApi',
  baseQuery: createBaseQuery('integrations', { timeout: 0 }),
  endpoints: builder => ({
    getKnowMyJourneys: builder.query({
      query: () => '/knowmy/journeys',
      transformResponse: ({ result }) => result,
    }),
    getKnowMyJourney: builder.query({
      query: journeyId => `/knowmy/journeys/${journeyId}`,
      transformResponse: ({ result }) => result,
    }),
    launchKnowMyJourney: builder.mutation({
      query: params => ({
        url: '/knowmy/journeys',
        method: 'POST',
        body: params,
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useGetKnowMyJourneysQuery,
  useLazyGetKnowMyJourneyQuery,
  useLaunchKnowMyJourneyMutation,
} = integrationApi;
